import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { MasterApi } from '~/api';

export var state = function state() {
	return {
		accountTypeSoles: [],
		accountTypeDolares: [],
		commercialAddressProvinces: [],
		administrativeAddressProvinces: [],
		commercialAddressDistricts: [],
		administrativeAddressDistricts: []
	};
};

export var mutations = {
	setKeyValue: function setKeyValue(state, _ref) {
		var key = _ref.key,
		    value = _ref.value;

		if (!state[key]) return;

		state[key] = value;
	}
};

export var actions = {
	loadAccountTypesSoles: function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, idBank) {
			var commit = _ref2.commit;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.t0 = commit;
							_context.next = 3;
							return new MasterApi(this.$axios).findAllTypeAccountByBank({ idBank: idBank });

						case 3:
							_context.t1 = _context.sent;
							_context.t2 = {
								key: 'accountTypeSoles',
								value: _context.t1
							};
							(0, _context.t0)('setKeyValue', _context.t2);

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function loadAccountTypesSoles(_x, _x2) {
			return _ref3.apply(this, arguments);
		}

		return loadAccountTypesSoles;
	}(),
	loadAccountTypesDolares: function () {
		var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4, idBank) {
			var commit = _ref4.commit;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.t0 = commit;
							_context2.next = 3;
							return new MasterApi(this.$axios).findAllTypeAccountByBank({ idBank: idBank });

						case 3:
							_context2.t1 = _context2.sent;
							_context2.t2 = {
								key: 'accountTypeDolares',
								value: _context2.t1
							};
							(0, _context2.t0)('setKeyValue', _context2.t2);

						case 6:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function loadAccountTypesDolares(_x3, _x4) {
			return _ref5.apply(this, arguments);
		}

		return loadAccountTypesDolares;
	}(),
	setProvinces: function setProvinces(_ref6, _ref7) {
		var commit = _ref6.commit;
		var addressPropertyType = _ref7.addressPropertyType,
		    provinces = _ref7.provinces;

		commit('setKeyValue', {
			key: addressPropertyType + 'Provinces',
			value: provinces
		});
	},
	setDistricts: function setDistricts(_ref8, _ref9) {
		var commit = _ref8.commit;
		var addressPropertyType = _ref9.addressPropertyType,
		    districts = _ref9.districts;

		commit('setKeyValue', {
			key: addressPropertyType + 'Districts',
			value: districts
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/master-data/affiliation-in-process.js
// module id = ./src/store/master-data/affiliation-in-process.js
// module chunks = 34